const BRANDED_CUSTOMER_PORTAL_HOST = "portal.everydaybullion.co.uk";

export interface CustomerPortalBrowserLocation {
  hostname: string;
  pathname: string;
  search: string;
  hash: string;
}

/**
 * Route the branded portal host's root and retired `/customer/portal` links
 * into the full customer experience on the same host.
 */
export function getBrandedCustomerPortalRedirect(
  location: CustomerPortalBrowserLocation,
): string | null {
  if (location.hostname.toLowerCase().replace(/\.$/, "") !== BRANDED_CUSTOMER_PORTAL_HOST) {
    return null;
  }

  let path: string | null = null;
  if (location.pathname === "/") {
    path = "/portal";
  } else if (
    location.pathname.toLowerCase() === "/customer/portal/notifications"
  ) {
    // Notification preferences and push controls live in the standalone
    // customer app mounted at /customer/, not in the root portal router.
    return null;
  } else if (/^\/customer\/portal(?:\/|$)/i.test(location.pathname)) {
    path = location.pathname.slice("/customer".length);
  }
  if (!path) return null;

  return `${path}${location.search}${location.hash}`;
}
